import { useEffect } from "react";

export function useExitIntent(onTrigger) {
  useEffect(() => {
    const handleMouseLeave = (e) => {
      if (e.clientY <= 0) {
        onTrigger();
      }
    };

    document.addEventListener("mouseleave", handleMouseLeave);
    return () => document.removeEventListener("mouseleave", handleMouseLeave);
  }, [onTrigger]);

  // Mobile scroll detection
  useEffect(() => {
    let lastY = window.scrollY;

    const handleScroll = () => {
      const current = window.scrollY;
      const diff = lastY - current;

      if (diff > 50) { 
        onTrigger();
      }

      lastY = current;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [onTrigger]);
}
